import { Selects } from './selects'

let observer
let config
let selectList = []

const button = (label) => {
    let div = document.createElement('div')
    div.innerHTML = `<div class="js-btn"><button data-color="white" class="u-btn">
        <span>${label}</span>
        <div class="u-btn__background"></div>
        <div aria-hidden="true" focusable="false" class="u-btn__icon">
            <div class="u-btn__icon-wrap">
                <svg>
                    <use xlink:href="/application/themes/the_escape/assets/images/svgicons.svg#arrow-right"></use>
                </svg>
            </div>
        </div>
    </button></div>`
    return div.firstElementChild
}

export function SpotlerForms() {
    let formEls = document.querySelectorAll('.js-spotler')
    let forms = Array.from(formEls)

    if (!formEls.length) {
        return
    }

    config = { attributes: true, childList: true, subtree: true }
    observer = new MutationObserver(mutationHandler)

    forms.forEach((form) => {
        observer.observe(form, config)

        let js = form.dataset.js
        let script = document.createElement('script')
        script.src = js
        document.body.appendChild(script)
    })
}

function mutationHandler(mutationList) {
    for (let i = 0; i < mutationList.length; i++) {
        let { type, target } = mutationList[i]
        if (type !== 'childList') {
            continue
        }

        let selectEls = target.querySelectorAll('.gf__control__input--select')
        Array.from(selectEls).forEach((select) => {
            if (select && !selectList.includes(select)) {
                selectList.push(select)

                select.classList.add('js-select')
                Selects(select.parentElement)

                let control = select.closest('.gf__control')
                control.classList.add('c-form__select-group')
            }
        })

        let buttonEls = target.querySelectorAll('.gf__submit')
        Array.from(buttonEls).forEach((buttonEl) => {
            if (
                !buttonEl.previousElementSibling ||
                !buttonEl.previousElementSibling.classList.contains('js-btn')
            ) {
                console.log(buttonEl)
                let label = buttonEl.value
                let newButton = button(label)
                buttonEl.parentElement.insertBefore(newButton, buttonEl)
                buttonEl.hidden = true
            }
        })
    }
}
